import { MenuItem } from '@/pages/ISWAN_APP/Workspace/components/Menu/Menu';
import icon_chart from './image/icon_chart.png';
import icon_chat from './image/icon_chat.png';
import icon_know from './image/icon_know.png';
import icon_robot from './image/icon_robot.png';
import icon_think from './image/icon_think.png';
import icon_work from './image/icon_work.png';

export const aiToolsList: MenuItem[] = [
  { key: 'Chat', icon: icon_chat, title: 'IYB Chat' },
  { key: 'Knowledge', icon: icon_know, title: 'IYB 知识库' },
  // { key: 'App', icon: icon_work, title: 'IYB 工作助手' },
  // { key: 'Decision', icon: icon_chart, title: 'IYB 数据分析' },
  // { key: 'Analyze', icon: icon_think, title: 'IYB 智脑决策' },
  // { key: 'Robot', icon: icon_robot, title: 'IYB Robot' },
];
